var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<ninja-grid no-data-text=\"No menu items yet...\" grid-title=\"Section Menu Items\" doc-svc=\"vm.docSvc\" list=\"vm.docSvc.doc.sections[vm.docSvc.activeObj.index].items\" create-method=\"openAddFood\" update-method=\"\" delete-method=\"deleteMenuItem\" details-link-method=\"vm.ninjaGridDetailsLink\" show-details-link=\"true\" add-toggle=\"vm.toggleAddMenuItems\" fields=\"{name: {input: 'text', header: 'Menu Item', order: 10, width: 25, type: 'string'}, description: {input: 'textarea', header: 'Description', order: 20, width: 50, type: 'string'},prices: {input: 'array', header: 'Price', order: 40, width: 10, type: 'array', viewDisplay: 'price', viewDisplayAs: 'currency'}}\"></ninja-grid>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/production/menus/tabs/section-food.jade
// module id = 198
// module chunks = 0